import React, { ReactChild } from "react";
import styled from "styled-components";
import { Heading } from "./Heading";

const LearnMoreSectionContainer = styled.div`
  width: 100%;
`;

export const CardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
`;

type Props = {
  title?: string;
  className?: string;
  children: ReactChild[] | ReactChild;
};

export const LearnMoreSection: React.FC<Props> = ({ title, className, children }) => {
  return (
    <LearnMoreSectionContainer className={className}>
      {title && <Heading level="h3">{title}</Heading>}
      <CardsContainer>{children}</CardsContainer>
    </LearnMoreSectionContainer>
  );
};
